var Handlebars = require("/root/project/webapp/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div>\n    <div class=\"timeline-model-at\">\n        <a class=\"push-state\" href=\""
    + alias2(alias1((depth0 != null ? depth0.modelURLAt : depth0), depth0))
    + "\">\n            <i class=\"fa fa-history\"></i>\n            "
    + alias2(__default(require("/root/project/webapp/src/common/ui/template/helper/i18n.js")).call(alias3,"balus_template_timeline:additional.model-at",{"name":"i18n","hash":{},"data":data}))
    + "\n        </a>\n        <a class=\"push-state\" href=\""
    + alias2(alias1((depth0 != null ? depth0.modelDiffURLFrom : depth0), depth0))
    + "\">\n            <i class=\"fa fa-random\"></i>\n            "
    + alias2(__default(require("/root/project/webapp/src/common/ui/template/helper/i18n.js")).call(alias3,"balus_template_timeline:additional.model-diff-from",{"name":"i18n","hash":{},"data":data}))
    + "\n        </a>\n    </div>\n</div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.showModelURLAt : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "<div class=\"action-list\"></div>\n<div class=\"content-version-list\"></div>\n<div class=\"diagram-list\"></div>\n<div class=\"record-list\"></div>\n<div class=\"relation-list\"></div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./balus/ui/template/additional/index.hbs
// module id = 924
// module chunks = 0